import { initData } from './tg.js';

type Listener = (env: any) => void;

export class MiniappWs {
  private ws: WebSocket | null = null;
  private listeners = new Set<Listener>();
  private subscribed = new Set<string>();
  private reconnectTimer: ReturnType<typeof setTimeout> | null = null;
  private shouldRun = false;

  start(): void {
    this.shouldRun = true;
    this.connect();
  }

  stop(): void {
    this.shouldRun = false;
    if (this.reconnectTimer !== null) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (this.ws) {
      try { this.ws.close(1000, 'stop'); } catch { /* ignore */ }
      this.ws = null;
    }
  }

  on(fn: Listener): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  send(env: unknown): void {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(env));
    }
  }

  subscribe(sessionId: string): void {
    this.subscribed.add(sessionId);
    this.send({ type: 'session.subscribe', payload: { session_id: sessionId } });
  }

  unsubscribe(sessionId: string): void {
    this.subscribed.delete(sessionId);
    this.send({ type: 'session.unsubscribe', payload: { session_id: sessionId } });
  }

  private connect(): void {
    if (!this.shouldRun) return;
    const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
    const ws = new WebSocket(`${proto}//${location.host}/ws/miniapp`);
    this.ws = ws;

    ws.addEventListener('open', () => {
      ws.send(JSON.stringify({ type: 'hello', payload: { init_data: initData() } }));
      // Re-subscribe after reconnect
      for (const sid of this.subscribed) {
        ws.send(JSON.stringify({ type: 'session.subscribe', payload: { session_id: sid } }));
      }
    });

    ws.addEventListener('message', (ev) => {
      let parsed: unknown;
      try { parsed = JSON.parse(ev.data); } catch { return; }
      for (const fn of this.listeners) fn(parsed);
    });

    ws.addEventListener('close', () => {
      this.ws = null;
      if (!this.shouldRun) return;
      this.reconnectTimer = setTimeout(() => this.connect(), 1500);
    });

    ws.addEventListener('error', () => { /* close will follow */ });
  }
}

export const wsClient = new MiniappWs();
